import { z } from "zod";
import { zId, zMiktar, zPara } from "./sozlesme.js";
export const zMalKabulTaslak = z.object({
    nokta_id: zId,
    firma: z.string().trim().max(200),
    fis_tarihi: z.string().date(),
    fis_no: z.string().trim().max(100).default(""),
    satirlar: z.array(z.object({
        urun_id: zId,
        miktar: zMiktar,
        birim_alis: z.preprocess((v) => v === "" ? null : v, zPara.nullable().default(null)),
        son_kullanma: z.string().date().nullable().default(null),
        parti_kodu: z.string().trim().max(64).nullable().default(null),
    })).max(500),
    belge_idler: z.array(zId).max(10).refine((v) => new Set(v).size === v.length, "Aynı belge iki kez eklenemez.").default([]),
});
//# sourceMappingURL=malKabul.js.map